import { Box } from '@mui/material'
import lockupSecondary from '../../assets/MISC_Full_Type_Lockup_Secondary.png'

export function MiscLogo({ light = false }: { light?: boolean }) {
  return (
    <Box
      component="img"
      src={light ? '/assets/brand/MISC_Full_Type_Lockup_Primary.png' : lockupSecondary}
      alt="MISC"
      sx={{ height: 48, width: 'auto', maxWidth: 240, display: 'block' }}
    />
  )
}
